export default {
  methods: {
    /**
     * Имеет ли компонент этот слот.
     *
     * @param {String} slot
     * @returns {boolean}
     */
    hasSlot (slot) {
      return !!this.$slots[slot]
    }
  }
}
